import { computed } from 'vue';
import { useBrand } from '~/composables/useBrand';
import { capitalizeOnlyFirstWord } from '~/utils/capitalize';
import { useProduct } from '~/modules/product/composables/useProduct';
import { useProductFlags } from '~/modules/featureControl/composables/useProductFlags';

export default function useNewMarkdownMaster() {
  const { productData } = useProduct();
  const { isBcom } = useBrand();
  const { isMasterProductFlag } = useProductFlags();
  const newMarkdownText = productData.pricing?.price?.priceType?.text;
  const newMarkdown = computed(() => {
    if (isBcom && isMasterProductFlag && newMarkdownText) {
      return capitalizeOnlyFirstWord(newMarkdownText);
    }
    return '';
  });
  return { newMarkdown };
}
